import { Routes, Route } from 'react-router-dom'
import Header from '../components/header'
import Main from './main/main'
import styles from './Routes.module.scss'

const App = () => {
  return (
    <div className={styles.app}>
      <Header />
      <Routes>
        <Route path='/' element={<Main />} />
      </Routes>
    </div>
  )
}

export default App
